import React from 'react';

// Icons
import { ArrowRight } from 'lucide-react';

// Images
import Step0MobileImg from '../../assets/images/WelcomeQuestions/Step0MobileImg.png';
import Step0Img from '../../assets/images/WelcomeQuestions/Step0Img.png';

// Material Ui (hook only)
import { useMediaQuery } from '@mui/material';

// UI kit
import { Button } from '@/components/ui';

const Step0WelcomeQuestion = ({ handleChange }) => {

    const matches = useMediaQuery('(min-width: 900px)');

    return (
        <div className="flex flex-col items-center text-center">
            <img
                src={ matches ? Step0Img : Step0MobileImg }
                alt="Bienvenida a WhatsPRO"
                className="mx-auto w-3/4 max-w-[240px]"
            />
            <h1 className="mt-6 text-2xl font-bold tracking-[-0.02em] text-foreground text-balance">
                Bienvenido a WhatsPRO
            </h1>
            <p className="mt-2 max-w-xs text-sm text-muted-foreground">
                Completá los siguientes pasos y comenzá a vender más y atender mejor
            </p>
            <Button onClick={ handleChange } className="mt-8 w-full">
                Comenzar
                <ArrowRight className="h-4 w-4" />
            </Button>
        </div>
    )
}

export default Step0WelcomeQuestion;
